var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { ReportingSegmentOption, ReportingFilterOption } from "@irati/types";
import { FormattedMessage } from "@irati/utils/lang";
import authentication from "@irati/auth";
import service from "@irati/reporting/services/reporting";
import { Para } from "@irati/ui/src/Labels";
import { RouterLink } from "@irati/ui/src/Link";
import { PerkRedemptionsChart } from "../../components/ReportingV3/Chart";
import { SegmentAndFilterWrapper } from "../../components/ReportingV3";
import { ViewType } from "../../components/ReportingV3/helpers";
var RedemptionDrilldown = /** @class */ (function (_super) {
    __extends(RedemptionDrilldown, _super);
    function RedemptionDrilldown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            view: ViewType.GRAPH
        };
        return _this;
    }
    RedemptionDrilldown.prototype.fetchRedemptionsData = function (startDate, endDate, segment, filters) {
        var _this = this;
        var tenantId = authentication.userTenant().uuid;
        service.getPerkRedemptions({ tenantId: tenantId, startDate: startDate, endDate: endDate, segment: segment, filters: filters }).then(function (perkRedemptions) {
            _this.setState({ perkRedemptions: perkRedemptions });
        });
    };
    RedemptionDrilldown.prototype.render = function () {
        var _this = this;
        var search = this.props.location.search;
        var _a = this.state, perkRedemptions = _a.perkRedemptions, view = _a.view;
        return (React.createElement(React.Fragment, null,
            React.createElement(RouterLink, { to: "reporting-v3/home" },
                React.createElement(FormattedMessage, { id: "admin.reportingV3.drilldown.backToReporitng" })),
            React.createElement(SegmentAndFilterWrapper, { fetch: this.fetchRedemptionsData.bind(this), view: view, handleViewChange: function (newView) { return _this.setState({ view: newView }); }, search: search, segments: [
                    ReportingSegmentOption.PerkUuid,
                    ReportingSegmentOption.PerkCategory,
                    ReportingSegmentOption.PerkType,
                    ReportingSegmentOption.Team
                ], filters: [
                    ReportingFilterOption.PerkUuid,
                    ReportingFilterOption.PerkCategory,
                    ReportingFilterOption.PerkType,
                    ReportingFilterOption.Team
                ] },
                view === ViewType.GRAPH && React.createElement(PerkRedemptionsChart, { data: (perkRedemptions === null || perkRedemptions === void 0 ? void 0 : perkRedemptions.series) || {} }),
                view === ViewType.TABLE && React.createElement(Para, null, "I am a placeholder table view "))));
    };
    return RedemptionDrilldown;
}(PureComponent));
export default RedemptionDrilldown;
